/**
 * sidebar 制御
 */
if($('.sidebar').length) {
  /**
   * サイドバーの表示サイズを設定
   * @type   {Function}
   * @return {Number}   設定するサイドバーの表示サイズ
   */

  const setSidebarDisplay = function() {
    let sidebarDisplay;
    if ($(window).width() > 767) {
      // sidebarDisplay = 192;
      // sidebarのサイズを取得
      sidebarDisplay = 48;
    } else {
      sidebarDisplay = 272;
    }
    return sidebarDisplay;
  };

  /**
   * ターゲットとなる要素を設定
   * @type   {Function}
   * @return {Object}
   */
  const setTgtElem = function() {
    let targetElem;
    if ($('.container').length) {
      targetElem = $('.container');
    } else {
      targetElem = $('.container-fluid');
    }
    return targetElem;
  }

  /**
   * サイドバーの制御
   * @type {Function}
   */
  const sidebarOperation = function() {
    /**
     * サイドバーの表示サイズを取得
     * @type {Number}
     */
    const sidebarDisplay = setSidebarDisplay();
    if($(window).width() < 1025) {
      /**
       * タッチデバイス用コード
       */

       ////////////// このプロジェクトで無効
      // if(parseInt($('.sidebar').css('left')) == (0 - sidebarDisplay)){
      //   $('.sidebar').animate({
      //     left: 0
      //   }, 300);
      // } else {
      //   $('.sidebar').animate({
      //     left: (0 - sidebarDisplay)
      //   }, 300,function () {
      //     $('.sidebar').attr('style', '');
      //   });
      // }
    } else {
      /**
       * PC用コード
       */
      /**
       * ターゲットとなる要素を取得
       * @type {Object}
       */
      const container = setTgtElem();
      ////////////// このプロジェクトで無効
      if(parseInt($('.sidebar').css('left')) == 0 && parseInt(container.css('margin-left')) != sidebarDisplay){
        $('.sidebar').animate({
          left: (0 - sidebarDisplay)
        }, 300,function () {
          $('.sidebar').attr('style', '');
        });
      } else {
        $('.sidebar').animate({
          left: 0
        }, 300);
      }
    }
  };

  /**
   * Sidebarの表示・非表示制御
   * @namespace .abuiSidebar
   */
  $(document).off('click.abuiSidebar', '.sidebar li a, .sidebar-toggle');
  $(document).on('click.abuiSidebar', '.sidebar li a, .sidebar-toggle', function() {
    sidebarOperation();
  });

  /**
   * タッチデバイスでサイドバー領域外をタップした時
   */
  $(document).off('touchend.abuiSidebar');
  $(document).on('touchend.abuiSidebar', function(e) {
    /**
     * サイドバーの表示サイズを取得
     * @type {Number}
     */
    const sidebarDisplay = setSidebarDisplay();

    const sidebarOpen = $('.sidebar').css('left');



    ////////////// このプロジェクトで無効
    // if($(e.target).closest('.wrapper').length && $(window).width() < 1366 && sidebarOpen === '0px') {
    //   $('.sidebar').animate({left:0-sidebarDisplay},300,function(){$('.sidebar').attr('style','')});
    // }
  });

  $(document).off('click.abuiSidebar', '.wrapper');
  $(document).on('click.abuiSidebar', '.wrapper', function() {
    /**
     * サイドバーの表示サイズを取得
     * @type {Number}
     */
    const sidebarDisplay = setSidebarDisplay();

    /**
     * ターゲットとなる要素を取得
     * @type {Object}
     */
    const container = setTgtElem();
    ////////////// このプロジェクトで無効
    if(parseInt($('.sidebar').css('left')) == 0 && parseInt(container.css('margin-left')) != sidebarDisplay){
      $('.sidebar').animate({
        left: (0 - sidebarDisplay)
      }, 300,function () {
        $('.sidebar').attr('style', '');
      });
    }
  });

  /**
   * ネストされたsidebar内メニュー項目の開閉処理
   */
  $(document).off('.abuiSidebar', '.expander');
  $(document).on('click.abuiSidebar', '.expander', function(){
    $(this).toggleClass('open').nextAll('.expander-target').slideToggle('fast');
    if($(this).hasClass('open') == false) {
      const subSection = $(this).nextAll('.expander-target').find('.expander');
      subSection.removeClass('open').nextAll('.expander-target').slideUp('fast');
    }
    // リンクがないメニューをクリックした時は無効
    if($(this).children('a').hasClass('temp-linkless')) {
      return false;
    }
  });
}
